import { View, Text } from "react-native";
import React, { useState } from "react";
import Accordion from "react-native-collapsible/Accordion";
import { MaterialCommunityIcons } from "@expo/vector-icons";

type Faq = {
  question: string;
  answer: string;
};

const renderHeader = (faq: Faq, expanded: boolean) => {
  return (
    <View className="flex-row justify-between p-10 bg-white rounded-lg my-2">
      <Text>{faq.question}</Text>
      {expanded ? (
        <MaterialCommunityIcons size={24} name="minus" />
      ) : (
        <MaterialCommunityIcons size={24} name="plus" />
      )}
    </View>
  );
};

const renderContent = (faq: Faq) => {
  return (
    <View className="p-8 text-white">
      <div dangerouslySetInnerHTML={{ __html: faq.answer }}></div>
    </View>
  );
};

const Faqs = ({
  faqs,
}: {
  faqs: Array<{
    question: string;
    answer: string;
  }>;
}) => {
  const [activeSections, setActiveSections] = useState<number[]>([]);

  const faqExpanded = (faq: Faq) => {
    if (activeSections.length === 0) return false;
    return faqs[activeSections[0]].question === faq.question;
  };

  return (
    <Accordion
        underlayColor="transparent"
        activeSections={activeSections}
        sections={faqs}
        renderHeader={(faq) => renderHeader(faq, faqExpanded(faq))}
        renderContent={renderContent}
        onChange={setActiveSections}
      ></Accordion>
  );
};

export default Faqs;
